import { TermsTemplate } from "@/components/Templates";

export function TermsPage() {
  return <TermsTemplate />;
}
